module.exports = __webpack_public_path__ + "img/logo.feb9b940.png";